"use strict";

var registry = require('dynamic-module-registry');
var $ = require('lc-jquery');
var Tooltip = require('tooltip.js').default;
var selectOfferElement = document.getElementById('select-offer');
if (window.location.pathname.indexOf('/print') !== -1) {
  selectOfferElement.classList.add('select-offer-print');
  window.print();
} else {
  selectOfferElement.classList.remove('select-offer-print');
}
var isMobileDevice = function isMobileDevice() {
  return /Mobi/.test(navigator.userAgent);
};
var enableButton = function enableButton(id) {
  var button = document.getElementById(id);
  button.classList.add('button-continue-selected');
  button.innerText = 'Continue';
  button.removeAttribute('disabled');
};
var offerProductsForTracking = registry.get('offerProductsForTracking');
function highlightRadioButton() {
  var highlightCss = document.querySelector('.card-offer--selected');
  if (highlightCss) {
    highlightCss.classList.remove('card-offer--selected');
  }
  var radioId = document.querySelector('input:checked').getAttribute('data-id');
  var divId = 'checkBox-offer-div-' + radioId;
  document.getElementById(divId).classList.add('card-offer--selected');
  var radioSelected = document.querySelector('.inputclass--selected');
  if (radioSelected) {
    radioSelected.classList.remove('inputclass--selected');
  }
  var inputClassId = 'radio-input-id-' + radioId;
  document.getElementById(inputClassId).classList.add('inputclass--selected');
  var elements = document.getElementsByClassName('button-continue-selected');
  if (elements.length > 0) {
    elements[0].innerText = 'Select Option';
    elements[0].setAttribute('disabled', 'disabled');
    elements[0].classList.remove('button-continue-selected');
  }
  enableButton('mobile-button');
  if (radioId.toLowerCase().includes('ni')) {
    document.getElementById('mobile-subject-to-final-check').style.display = 'block';
    document.getElementById('mobile-subject-to-final-check-prp').style.display = 'block';
  } else if (radioId.toLowerCase().includes('prp')) {
    document.getElementById('mobile-subject-to-final-check').style.display = 'block';
    document.getElementById('mobile-subject-to-final-check-prp').style.display = 'none';
  } else {
    document.getElementById('mobile-subject-to-final-check').style.display = 'none';
    document.getElementById('mobile-subject-to-final-check-prp').style.display = 'none';
  }
  if (radioId.toLowerCase().includes('il')) {
    enableButton('IL-button');
  } else if (radioId.toLowerCase().includes('lcfrp')) {
    enableButton('LCFRP-button');
  } else if (radioId.toLowerCase().includes('lctni')) {
    enableButton('LCTNI-button');
  } else if (radioId.toLowerCase().includes('ni')) {
    enableButton('NI-button');
  } else if (radioId.toLowerCase().includes('prp')) {
    enableButton('Prp-button');
  }
}
function submit() {
  var selectedButtonID = $('.button-continue-selected').prop('id');
  $('.button-continue-selected').prop('disabled', true).removeClass('button-continue-selected');
  var radioButton = document.querySelector('input:checked'),
    queryMatch = window.location.search.match(/id=(\d+)/),
    applicationId = queryMatch.length > 1 ? queryMatch[1] : '',
    counterADS = $('#counter-offer-flag').val(),
    completeLoanProcess = $('#complete-loan-flag').val(),
    radioId = radioButton.id.toLowerCase();
  var postData = {
    id: applicationId,
    selectedOfferId: radioButton.value
  };
  if ((radioId.includes('ni') || radioId.includes('prp')) && counterADS === 'true' && completeLoanProcess === 'true') {
    postData.counterADS = true;
    postData.partialChange = false;
    postData.completeLoanProcess = true;
  } else {
    postData.partialChange = true;
  }
  if (radioId.includes('il')) {
    postData.prodType = 'IL';
    postData.providerAssociation = document.getElementById('provider-association').value;
    postData.banks = document.getElementById('banks').value;
  } else if (radioId.includes('lcfrp')) {
    postData.prodType = 'LC_FRP';
  } else if (radioId.includes('lctni')) {
    postData.prodType = 'LC_TNI';
  } else if (radioId.includes('ni')) {
    postData.prodType = 'IF';
  } else if (radioId.includes('prp')) {
    postData.prodType = 'PRP';
  }
  postData.offerProductsForTracking = offerProductsForTracking;
  var url = window.location.href;
  $.ajax({
    url: url,
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(postData)
  }).done(function (data) {
    var origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    window.location.href = data.redirect.indexOf('http') > -1 ? data.redirect : data.redirect[0] === '/' ? origin + data.redirect : origin + '/' + data.redirect;
  }).fail(function () {
    window.location.href = 'error';
  }).always(function () {
    $("#".concat(selectedButtonID)).prop('disabled', false).addClass('button-continue-selected');
  });
}
Array.prototype.forEach.call(document.querySelectorAll('.card-offer-checkbox'), function (ele) {
  ele.onclick = function (e) {
    highlightRadioButton();
  };
});
Array.prototype.forEach.call(document.querySelectorAll('.button-continue'), function (ele) {
  ele.onclick = function (e) {
    submit();
  };
});
Array.prototype.forEach.call(document.querySelectorAll('.counter-indicator'), function (ele) {
  new Tooltip(ele, {
    placement: 'top',
    delay: 200
  });
});
var offersPagePrintButtonElement = document.getElementById('offers-page-print-button');
if (offersPagePrintButtonElement) {
  if (isMobileDevice()) {
    offersPagePrintButtonElement.style.display = 'none';
  } else {
    offersPagePrintButtonElement.style.display = 'block';
  }
}
var application = registry.get('application');
if (application !== null && application !== void 0 && application.selectedOfferId) {
  $("input[value=".concat(application.selectedOfferId, "]")).trigger('click');
}
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-select-plan/dist/client/select-offer-v1.scss');